import { defineStore } from "pinia";
import { ref } from "vue";
let nextId = 1;
export const useToastStore = defineStore("toast", () => {
    const toasts = ref([]);
    function push(opts) {
        const id = nextId++;
        const ttlMs = opts.ttlMs ?? (opts.kind === "error" ? 6000 : 3000);
        toasts.value.push({ id, kind: opts.kind, message: opts.message, ttlMs });
        if (ttlMs > 0) {
            setTimeout(() => dismiss(id), ttlMs);
        }
        return id;
    }
    function dismiss(id) {
        toasts.value = toasts.value.filter((t) => t.id !== id);
    }
    function info(message) {
        return push({ kind: "info", message });
    }
    function success(message) {
        return push({ kind: "success", message });
    }
    function warning(message) {
        return push({ kind: "warning", message });
    }
    function error(message) {
        return push({ kind: "error", message });
    }
    return { toasts, push, dismiss, info, success, warning, error };
});
